<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'CursorComp',
  render: (h) => h(),
  data: () => ({
    current: null,
  }),
  beforeDestroy() {
    _.each(this.$cursor, c => c.dispose())
    this.$scene.unregisterBeforeRender(this.beforeRender)
    this.$scene.onPointerObservable.remove(this.$click)
    this.$machine.dispose()
  },

  created() {

    const meshs = this.$parent.$meshs
    const camera = this.$parent.$camera
    const scene = this.$parent.$scene
    const ray = new BABYLON.Ray()
    const rayHelper = new BABYLON.RayHelper(ray)
    const localMeshDirection = new BABYLON.Vector3(0, 0, 1)
    const localMeshOrigin = new BABYLON.Vector3(0, 0, 0)
    const length = 200
    const oeuvres = this.$store.getters['app/oeuvres']

    // console.log(oeuvres);
    // _.each(oeuvres, (o)=>{
    //   console.log(o.name);
    // })

    this.$scene = scene
    this.$ray = ray
    this.$camera = camera
    this.$oeuvres = _.map(oeuvres, o => scene.getMeshByName(o.name))

    // console.log(this.$oeuvres);

    rayHelper.attachToMesh(camera, localMeshDirection, localMeshOrigin, length)

    this.$cursor = { on: null, off: null, beigne: null, full: null }
    _.each(this.$cursor, (c,k) => this.$cursor[k] = this.createPlane(k) )

    this.setHover()

    const machine = new BABYLON.MeshBuilder.CreateBox('Machine', { width: 8, depth: 10, height: 3 }, this.$scene)
    machine.material = new BABYLON.StandardMaterial('MAT_Machine', this.$scene)
    machine.material.alpha = 0
    machine.isActive = true
    machine.position = new BABYLON.Vector3(5, 59, -629)
    this.$machine = machine
    this.$oeuvres.push(this.$machine)

    const owner = scene.getMeshByName('o_Vitre')
    this.$owner = owner
    this.$oeuvres.push(this.$owner)

    this.$click = scene.onPointerObservable.add (evt => {

      if(this.current && this.slugIsIn(['explore:1', 'explore:2', 'explore:3', 'explore:4', 'grenier:2'])) {
        this.$store.commit('app/SET_OEUVRE', this.current)
        this.next()
        this.current = null
      }

      if(this.$route.meta.name == 'artwork' && !this.$route.params.id && this.current) {
        
        if(this.current == 'o_Vitre') {
          this.$router.push({ name: 'artwork.' + this.lang, params: { id: 1000 } })
        } else {
          this.$store.commit('app/SET_OEUVRE', this.current)
          this.$router.push({ name: 'artwork.' + this.lang, params: { id: this.oeuvre.id } })
        }
        
        this.current = null
      }

      if(this.current == 'Machine' && this.slugIsIn(['codec', 'tunnel:2']))
        this.next()

    }, BABYLON.PointerEventTypes.POINTERDOWN)

    scene.registerBeforeRender(this.beforeRender)
  },
  watch: {
    current() {
      this.setHover()
    },
    '$route': {
      immediate: true,
      handler() {

        if(this.slugIsAfter('pan'))
          this.nbActivated = 20

        if(this.$route.meta.name == 'artwork')
          this.$owner.isActive = true   
      }
    },
  },
  methods: {
    setHover() {
      
      if(this.current) {

        console.log(this.current);

        if(this.$route.meta.name == 'museum') {

          if(this.slugIsBefore('explore:1') && this.current != 'Machine' && this.current != 'o_CLAUDIE_GAGNON')
            return

          if(this.current != 'Machine' && this.slugIsIn(['codec']))
            return

          if(this.current != 'o_CLAUDIE_GAGNON' && this.slugIsIn(['grenier:2']))
            return

          if(this.slugIsIn(['use-tunnel', 'tunnel:1', 'tunnel:2']))
            return
        }

        _.each(this.$cursor, c => c.material.unfreeze())
        if(this.$freeze)
          this.$freeze.kill()

        this.$freeze = TweenMax.delayedCall(1, () => _.each(this.$cursor, c => c.material.unfreeze()))

        TweenMax.to(this.$cursor.on.material, .5, { alpha: 1 })
        TweenMax.to(this.$cursor.off.material, .5, { alpha: 0 })
        TweenMax.to(this.$cursor.full.material, .5, { alpha: 1 })
        TweenMax.to(this.$cursor.beigne.material, .5, { alpha: 0 })
        TweenMax.to(this.$cursor.full.scaling, .5, { x: 1, y: 1 })
      } else {
        TweenMax.to(this.$cursor.on.material, .5, { alpha: 0 })
        TweenMax.to(this.$cursor.off.material, .5, { alpha: 1 })
        TweenMax.to(this.$cursor.beigne.material, .5, { alpha: 1 })
        TweenMax.to(this.$cursor.full.scaling, .5, { x: 0, y: 0 })
      }
    },
    createPlane(image) {
      let size = .4
      if(image == 'full')
        size = .12
      if(image == 'beigne')
        size = .10

      const texture = new BABYLON.Texture(require('./img/cursor/' + image + '.png'), this.$scene)
      const plane = new BABYLON.MeshBuilder.CreatePlane('cursor', { size: size }, this.$scene)
            plane.parent = this.$camera
            plane.position.z = 5
            plane.isPickable = false
            plane.material = new BABYLON.StandardMaterial('MAT_plane_' + image, this.$scene)
            plane.material.useLogarithmicDepth = true
            plane.material.alpha = 1
            plane.material.alphaCutOff = .01
            plane.material.backFaceCulling = false
            plane.material.opacityTexture = texture
            plane.material.diffuseTexture = texture
            plane.material.emissiveTexture = texture

      return plane
    },
    
    beforeRender() {
      const hit = this.$ray.intersectsMeshes(this.$oeuvres)
      this.current = hit.length && hit[0].pickedMesh.isActive ? hit[0].pickedMesh.name : null
    },
    lookAt(mesh) {
      return new Promise(res => {
        const old = this.$camera.rotation.clone()
        this.$camera.setTarget(mesh.absolutePosition)
        const n = this.$camera.rotation.clone()
        this.$camera.rotation = old
        TweenMax.to(this.$camera.rotation, .5, {
          directionalRotation: {
            x: n.x + '_short',
            y: n.y + '_short',
            z: n.z + '_short',
            useRadians: true
          }, onComplete: () => res()
        })
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/world/elements/Cursor.vue